import { gsap } from './_gsap-core.js';

/**
 * Inicializa animações declaradas com o atributo [gsap]
 */
export function initGsapAnimations() {
   document.querySelectorAll('[gsap]').forEach(element => {
      const { duration, delay, anchor, ...props } = getAnimationProperties(element);
      const triggerElement = anchor ? document.querySelector(anchor) : element;

      const tl = gsap.timeline({
         scrollTrigger: {
            trigger: triggerElement,
            start: 'top bottom',
            end: 'top center',
            scrub: true,
         }
      });

      tl.from(element, { ...props, duration }, delay);
   });
}

/**
 * Converte atributos HTML em propriedades de animação
 */
function getAnimationProperties(element) {
   const animationType = element.getAttribute('gsap');
   const duration = parseFloat(element.getAttribute('gsap-duration')) || 1;
   const delay = parseFloat(element.getAttribute('gsap-delay')) || 0;
   const anchor = element.getAttribute('gsap-anchor');

   let props = {};

   switch (animationType) {
      case 'fade-in':
         props = { opacity: 0 };
         break;
      case 'slide-up':
         props = { y: 100 };
         break;
      case 'fade-up':
         props = { opacity: 0, y: 100 };
         break;
      case 'rotate-in':
         props = { rotation: 180 };
         break;
      default:
         props = { opacity: 0 };
   }

   return { ...props, duration, delay, anchor, ease: 'power2.out' };
}
